exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-markdown-remark-frontmatter-path-tsx": () => import("./../../../src/pages/{MarkdownRemark.frontmatter__path}.tsx" /* webpackChunkName: "component---src-pages-markdown-remark-frontmatter-path-tsx" */)
}

